import { render, staticRenderFns } from "./OutpatientTimeTable.vue?vue&type=template&id=5bfcc3ee&scoped=true"
import script from "./OutpatientTimeTable.vue?vue&type=script&lang=js"
export * from "./OutpatientTimeTable.vue?vue&type=script&lang=js"
import style0 from "./OutpatientTimeTable.vue?vue&type=style&index=0&id=5bfcc3ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfcc3ee",
  null
  
)

export default component.exports